module.exports = __webpack_public_path__ + "media/stockholm/subway_arrow-9c45fcae.jpg";